import React from 'react';
import '../Hello/Hello.css';

const statImages = [
  { image: '/g3.png', alt: 'Successful Events' },
  { image: '/g2.jpeg', alt: 'Expert Planners' },
  { image: '/g1.png', alt: 'Happy Clients' },
  { image: '/g4.png', alt: 'Industry Awards' }
];

const EventStats = () => {
  return (
    <section className="hello-section">
      <div className="hello-right">
        <h2><span>Events </span>Crafted With Passion </h2>
        <h4>India's Premier Event Management Company</h4>
        <p>
          We specialize in curating extraordinary experiences — from luxurious weddings to corporate galas
          and social gatherings. With a team of creative experts and logistics masters, we bring your
          vision to life with style, precision, and professionalism.
        </p>

        <div className="hello-bottom">
          <div className="hello-left">
            <div className="image-wrapper">
              <div className="border-light" style={{ '--animation-delay': '0s' }}></div>
              <img 
                src="/singer.JPG" 
                alt="Event" 
                className="hello-left-img" 
                loading="lazy" 
              />
            </div>
          </div>

          <div className="hello-stats">
            {statImages.map((stat, index) => (
              <div className="stat-item" key={index}>
                <div 
                  className="border-light" 
                  style={{ '--animation-delay': `${index * 0.5}s` }}
                ></div>
                <img 
                  src={stat.image} 
                  alt={stat.alt} 
                  className="stat-image" 
                  loading="lazy" 
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventStats;
